"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defer = defer;
exports.noncritical = noncritical;
exports.sequence = sequence;

var _utils = require("./utils");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function defer(func) {
  if (!(0, _utils.isServer)()) {
    return func;
  }

  return function () {
    return {
      status: 'loading',
      promise: Promise.resolve(),
      noncritical: true
    };
  };
}

function noncritical(func) {
  return function (iguazuInput) {
    var result = func(iguazuInput);
    return _objectSpread({}, result, {
      promise: result.promise.catch(function () {
        /* swallow */
      }),
      noncritical: true
    });
  };
}

function sequence(funcs) {
  var processedIndex = funcs.length;
  var mappedFuncs = {};
  var sequencedData = {};

  function processPrev() {
    processedIndex -= 1;
    var currIndex = processedIndex;
    var _funcs$currIndex = funcs[currIndex],
        key = _funcs$currIndex.key,
        handler = _funcs$currIndex.handler;
    var mappedFunc;

    if (currIndex === 0) {
      mappedFunc = handler;
    } else {
      var prevFunction = processPrev();
      var prevKey = funcs[currIndex - 1].key;

      mappedFunc = function mappedFunc() {
        var result = prevFunction();
        var prevPromise = result.promise,
            status = result.status,
            error = result.error,
            data = result.data,
            isNonCritical = result.noncritical;
        sequencedData = _objectSpread(_defineProperty({}, prevKey, data), sequencedData);
        var promise = prevPromise.then(function (prevData) {
          var prevDataMap = currIndex === 1 ? _defineProperty({}, prevKey, prevData) : prevData;
          return Promise.all([prevDataMap, handler(prevDataMap).promise]);
        }).then(function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
              prevDataMap = _ref3[0],
              currData = _ref3[1];

          return _objectSpread({}, prevDataMap, _defineProperty({}, key, currData));
        });

        if (status === 'loading') {
          return {
            status: 'loading',
            promise: promise
          };
        }

        if (error && isNonCritical !== true) {
          return {
            status: 'complete',
            error: error,
            promise: promise
          };
        }

        return Object.assign(handler(sequencedData), {
          promise: promise
        });
      };
    }

    mappedFuncs[key] = mappedFunc;
    return mappedFunc;
  }

  processPrev();
  return mappedFuncs;
}